<template>
	<div class="full-screen">
		<DcHeader title=" " />
		<div class="image-preview">
			<NuxtImg v-if="imageSrc" :src="imageSrc" alt="banner preview" class="preview-image" format="webp" />
			<div v-else class="empty-tip">暂无图片</div>
		</div>
	</div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import DcHeader from '@/components/DcHeader.vue';

const route = useRoute();
const imageSrc = ref('');

onMounted(() => {
	const fromStorage = window.sessionStorage.getItem('banner-image-preview') || '';
	const fromQuery = String(route.query?.imgUrl || '');
	imageSrc.value = fromStorage || fromQuery;
});
</script>

<style scoped lang="scss">
.full-screen {
	width: 100%;
	min-height: 100vh;
	background: #fff;
}

.image-preview {
	width: 100%;
	margin: 0 auto;
}

.preview-image {
	width: 100%;
	height: auto;
	display: block;
}

.empty-tip {
	padding: 2rem 1rem;
	text-align: center;
	color: #909399;
	font-size: 1rem;
}
</style>
